import StyledWrapper from "@insite/client-framework/Common/StyledWrapper";
import Zone from "@insite/client-framework/Components/Zone";
import PageProps from "@insite/client-framework/Types/PageProps";
import WidgetModule from "@insite/client-framework/Types/WidgetModule";
import GridContainer, { GridContainerProps, GridOffset } from "@insite/mobius/GridContainer";
import GridItem, { GridItemProps } from "@insite/mobius/GridItem";
import { HiddenProps } from "@insite/mobius/Hidden";
import breakpointMediaQueries from "@insite/mobius/utilities/breakpointMediaQueries";
import InjectableCss from "@insite/mobius/utilities/InjectableCss";
import * as React from "react";
import { css } from "styled-components";

export interface LogoLinksSearchStyles {
    container: InjectableCss;
    logoWrapper: InjectableCss;
    searchMenuWrapper: InjectableCss;
    linkListHidden: HiddenProps;
    signInCartContainer?: GridContainerProps;
    headerGridItemContainer?: GridItemProps;
    searchContainer: InjectableCss;
    mainNav: InjectableCss;
}

export const logoLinksSearchStyles: LogoLinksSearchStyles = {
    container: {
        css: css`
            display: flex;
            justify-content: flex-start;
            max-width: 1700px;
            padding: 5px 10px;
            margin: 0 auto;
            flex-wrap: nowrap;
            min-height: 100px;
            align-items: center;
        `,
    },
    logoWrapper: {
        css: css`
            display: flex;
            flex: 0 0 0%;
            text-align: left;
            padding: 0 40px 0 0;
            ${({ theme }) => {
                return breakpointMediaQueries(
                    theme,
                    [
                        null,
                        null,
                        css`
                            flex-grow: 1;
                        `,
                        null,
                        null,
                    ],
                    "max",
                );
            }}
            img {
                ${({ theme }) => {
                    return breakpointMediaQueries(
                        theme,
                        [
                            null,
                            null,
                            css`
                                height: 42px;
                                width: auto;
                                margin: 0;
                            `,
                            null,
                            null,
                        ],
                        "max",
                    );
                }}
            }
        `,
    },
    searchMenuWrapper: {
        css: css`
            display: flex;
            align-items: center;
            flex: 1 0 320px;
            justify-content: flex-end;
            padding: 0;
            margin-left: auto;
            margin-right: auto;
            ${({ theme }) => {
                return breakpointMediaQueries(
                    theme,
                    [
                        null,
                        css`
                            display: none;
                        `,
                        null,
                        null,
                        null,
                    ],
                    "max",
                );
            }}
        `,
    },
    linkListHidden: {
        below: "lg",
    },
    signInCartContainer: {
        css: css`
            display: flex;
            flex-direction: row;
            flex-wrap: nowrap;
            justify-content: flex-end;
        `,
    },
    headerGridItemContainer: {
        css: css`
            padding-top: 5px !important;
            padding-bottom: 5px !important;
            padding-left: 0;
            padding-right: 0;
            text-align: center;
        `,
    },
    searchContainer: {
        css: css`
            flex: 0 0 100%;
            width: 100%;
        `,
    },
    mainNav: {
        css: css`
            display: flex;
            flex: 0 2 43%;
            align-items: center;
            margin-left: auto;
            ${({ theme }) => {
                return breakpointMediaQueries(
                    theme,
                    [
                        null,
                        null,
                        null,
                        css`
                            flex: 0 2 15%;
                        `,
                        null,
                    ],
                    "max",
                );
            }}
        `,
    },
};

const LogoLinksSearch: React.FC<PageProps> = ({ id }) => (
    <div>
        <StyledWrapper id="headercontainer" {...logoLinksSearchStyles.container}>
            <StyledWrapper {...logoLinksSearchStyles.logoWrapper}>
                <Zone contentId={id} zoneName="Logo" />
            </StyledWrapper>
            <StyledWrapper {...logoLinksSearchStyles.mainNav}>
                <Zone contentId={id} zoneName="MainNavigation" />
            </StyledWrapper>
            <StyledWrapper {...logoLinksSearchStyles.searchMenuWrapper}>
                <StyledWrapper {...logoLinksSearchStyles.signInCartContainer}>
                    <StyledWrapper
                        width={3}
                        {...logoLinksSearchStyles.headerGridItemContainer}
                        style={{ minWidth: "100px" }}
                    >
                        <Zone contentId={id} zoneName="Support" />
                    </StyledWrapper>
                    <StyledWrapper width={3} {...logoLinksSearchStyles.headerGridItemContainer}>
                        <Zone contentId={id} zoneName="Quick Order" />
                    </StyledWrapper>
                    <StyledWrapper width={3} {...logoLinksSearchStyles.headerGridItemContainer}>
                        <Zone contentId={id} zoneName="Cart" />
                    </StyledWrapper>
                    <StyledWrapper width={3} {...logoLinksSearchStyles.headerGridItemContainer}>
                        <Zone contentId={id} zoneName="SignIn" />
                    </StyledWrapper>
                </StyledWrapper>
            </StyledWrapper>
        </StyledWrapper>
        <StyledWrapper {...logoLinksSearchStyles.searchContainer}>
            <Zone contentId={id} zoneName="Search"></Zone>
        </StyledWrapper>
    </div>
);

const logoLinksSearch: WidgetModule = {
    component: LogoLinksSearch,
    definition: {
        group: "Common",
        icon: "magnifying-glass",
        fieldDefinitions: [],
    },
};

export default logoLinksSearch;
